import { useStepper } from "../../../../components/ui/stepper";
import {
  RadioGroup,
  RadioGroupItem,
} from "../../../../components/ui/radio-group";
import { Label } from "../../../../components/ui/label";
import { Button } from "../../../../components/ui/button";
import { AnimatedTooltip } from "../../../../components/AnimatedTooltip";
import { LucideInfo } from "lucide-react";

export function RiskStepContent({
  section,
  sectionIndex,
  setSections,
  sections,
  fetchAnalysis,
  missingQuestions,
  missingTooltipContent,
}) {
  const { nextStep, prevStep, activeStep } = useStepper();

  const handleAnswer = (sectionIndex, questionIndex, value) => {
    setSections((prev) => {
      const updated = [...prev];
      updated[sectionIndex].questions[questionIndex].answer = value;
      return updated;
    });
  };

  // ✅ Check if all questions in this section are answered
  const allAnswered = section?.questions?.every((q) => q?.answer);
  return (
    <div className="h-auto flex flex-1 flex-col gap-4">
      <h2 className="text-lg font-semibold">{section.sub_title}</h2>

      <div className="flex flex-col gap-4 h-[490px] overflow-auto bg-muted rounded-md p-2">
        {section?.questions?.map((q, i) => {
          const topic = q?.label?.split("info")[0];
          const info =
            q?.label &&
            q?.label?.split("info")[1] &&
            q?.label?.split("info")[1]?.slice(1);
          const question = q?.question;
          const questionKey = `${section?.title}_${i}`;
          return (
            <div
              key={i}
              className={`border p-3 rounded-md flex flex-col gap-3 bg-background ${missingQuestions?.includes(i) ? "border-webPrimary border-2" : ""}`}
              style={{
                borderColor:
                  q?.answer === "Yes"
                    ? section?.yes_color
                    : q?.answer === "No"
                      ? section?.no_color
                      : undefined,
              }}
            >
              <p>
                <div className="font-medium flex items-center gap-2">
                  <strong className="mr-1 text-webPrimary">{i + 1}.</strong>
                  {topic}:{" "}
                  {info && (
                    <AnimatedTooltip
                      title={
                        <>
                          <a
                            href={`${info}`}
                            target="_blank"
                            className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 dark:hover:bg-webSecondary transition-colors"
                            rel="noreferrer"
                          >
                            {info}
                          </a>
                        </>
                      }
                      leftAlign={true}
                    >
                      <LucideInfo className="h-4 w-4 text-webPrimary" />
                    </AnimatedTooltip>
                  )}
                </div>
                {question}
              </p>
              <RadioGroup
                value={q.answer || ""}
                onValueChange={(value) => handleAnswer(sectionIndex, i, value)}
                className="flex gap-6"
              >
                {["Yes", "No"]?.map((option) => (
                  <div key={option} className="flex items-center space-x-2">
                    <RadioGroupItem
                      value={option}
                      id={`${questionKey}_${option}`}
                    />
                    <Label
                      htmlFor={`${questionKey}_${option}`}
                      className="cursor-pointer"
                    >
                      {option}
                    </Label>
                  </div>
                ))}
              </RadioGroup>
            </div>
          );
        })}
      </div>

      {/* Navigation Buttons */}
      <div className="flex justify-end gap-3 relative">
        {/* <AnimatedTooltip
          title={missingTooltipContent}
          leftAlign={true}
          bottomAlign={false}
          className={"items-end justify-end bottom-10"}
        > */}
          {missingQuestions?.length > 0 && (
            <div className="text-webPrimary relative">
              {missingQuestions.length} question(s) remaining
            </div>
          )}
        {/* </AnimatedTooltip> */}
        {activeStep > 0 && (
          <Button variant="secondary" onClick={prevStep}>
            Previous
          </Button>
        )}

        {activeStep < sectionIndex + 1 ? (
          !allAnswered ? (
            <AnimatedTooltip
              title={" Please answer all questions before proceeding"}
            >
              <Button onClick={nextStep} disabled={!allAnswered}>
                Next
              </Button>
            </AnimatedTooltip>
          ) : (
            <Button
              onClick={() => {
                nextStep();
                if (activeStep === sections.length - 1) {
                  fetchAnalysis(sections);
                }
              }}
              disabled={!allAnswered}
            >
              Next
            </Button>
          )
        ) : (
          <Button type="submit">Submit</Button>
        )}
      </div>
    </div>
  );
}
